'use client';
import AccountTabView from '@/app/[locale]/(protected)/(dashboard)/ui/AccountTabView';
import TabTitleRender, { ITabConfig } from '@/app/[locale]/(protected)/(dashboard)/ui/TabTitleRender';
import { ReturnedAccount } from '@common/model/apiClient/Account';
import { User } from '@common/model/apiClient/User';
import { useQuery } from '@tanstack/react-query';
import { TabPanel } from 'devextreme-react';
import { useSession } from 'next-auth/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './AccountDashboard.module.css';

interface AccountDashboardProps {}

function AccountDashboard(props: AccountDashboardProps) {
  const { data: session } = useSession();

  const {
    data: favouritesData,
    refetch: refetchFavourites,
    isFetching: favouritesFetching,
  } = useQuery({
    queryKey: [session?.user?.userId, 'fav_accounts'],
    queryFn: () => User.getFavouriteAccounts(session?.user?.userId!),
    enabled: !!session?.user?.userId,
  });

  const { isFetching: accountHistoryFetching, data: accountHistoryData } = useQuery({
    queryKey: [session?.user?.userId, 'user_history'],
    queryFn: () => User.getHistory(session?.user?.userId!),
    enabled: !!session?.user?.userId,
  });

  const tabsConfig: ITabConfig<ReturnedAccount>[] = [
    {
      icon: 'star',
      title: <FormattedMessage defaultMessage={'Favourite Accounts'} description={'Accounts that have been marked as Favourite by user'} />,
      data: favouritesData?.data?.payload ?? [],
      id: 'favourites',
    },
    {
      icon: 'eye',
      title: <FormattedMessage defaultMessage={'Recently Viewed Accounts'} description={'Recently Visited Accounts'} />,
      data: accountHistoryData?.data?.payload.accounts ?? [],
      id: 'history',
    },
    {
      icon: 'magnifying-glass',
      title: <FormattedMessage defaultMessage={'Search Accounts'} description={'Home page title'} />,
      data: [],
      id: 'search',
    },
    // {
    //   icon: 'tag',
    //   title: <FormattedMessage defaultMessage={'Tagged Accounts'} />,
    //   data: [],
    //   id: 'tags',
    //   selectedTags,
    //   setSelectedTags,
    // },
  ];

  return (
    <div className={styles.container}>
      <TabPanel dataSource={tabsConfig} itemTitleRender={TabTitleRender} itemComponent={AccountTabView} animationEnabled={false} />
    </div>
  );
}

export default AccountDashboard;
